
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import _ from 'lodash';
import { EXPORT_PND_FORM } from 'src/constants/FormNames';
import Button from 'jbc-front/components/Button';
import CommonModal from 'jbc-front/components/CommonModal';
import { ErrorsSection } from 'src/components';
import { FormSubmitBtn } from 'src/buttons';
import styles from './ExportPndModal.scss';
import { useTranslation } from 'react-i18next';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { SelectField, RadioField } from 'src/jbc-front/components/Form';
import { PND_OPTIONS } from 'src/constants/Options';

const ExportPndInsideForm = ({
  errors,
  submitting,
  submit,
  isOpen,
  hideModal,
  paymentRange,
  onModalHide,
  offices
}) => {
  const { t } = useTranslation();
  const yearMonth = _.get(paymentRange, 'yearMonth', '_').split('_');
  const header = `${t('features.EmployeePays.components.ExportPndModal.Data_Export_for_Online_PND1_Submission')}　＜${yearMonth[1]}/${yearMonth[0]}＞`;

  const [office, setOffice] = useState();
  const selectExport = (e, newValue) => {
    if (newValue == 'select_branch') {
      setOffice('select_branch');
    } else {
      setOffice(null);
    }
  };

  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal, onModalHide }}>
      <CommonModal.Header hideModal={hideModal}>{header}</CommonModal.Header>
      <CommonModal.Body>
        <form className={styles.form}>
          <p className="u-mb40">{t('features.EmployeePays.components.ExportPndModal.Export_data_required_for_online_PND1_submission')}</p>

          <RadioField
            name="export_type"
            label={t('features.EmployeePays.components.ExportPndModal.export_method')}
            options={PND_OPTIONS}
            onChange={selectExport}
            required
          />

          {office == 'select_branch' && 
            <SelectField required label={t('features.EmployeePays.components.ExportPndModal.select_branch')} name="client_branch_id" options={offices} />
          }

          <ErrorsSection errors={errors} />
        </form>
      </CommonModal.Body>
      <CommonModal.Footer>
        <Button onClick={hideModal} className="u-mr20">
          {t('features.EmployeePays.components.ExportPndModal.Cancel')}
        </Button>
        <FormSubmitBtn text={t('features.EmployeePays.components.ExportPndModal.Export')} {...{submitting, submit }} />
      </CommonModal.Footer>
    </CommonModal>
  );
};

const ExportPndForm = reduxForm({
  form: EXPORT_PND_FORM
})(ExportPndInsideForm);

const ExportPndModal = ({ paymentRange, errors, onModalHide, handleSubmit, isOpen, hideModal, offices }) => (
  <ExportPndForm
    isOpen={isOpen}
    hideModal={hideModal}
    onSubmit={values => handleSubmit(values, paymentRange)}
    paymentRange={paymentRange}
    errors={errors}
    onModalHide={onModalHide}
    offices={offices}
  />
);

export default connect(state => ({
  offices: getSelectOptions(state, 'offices')
}))(ExportPndModal);